import type { GardenType } from '@ui/utils/garden';

import type { CoinMode } from './useCoinMode';
import useFerroLpBalance from './useFerroLpBalance';
import useTLcroBalance from './useTLcroBalance';
import useVvsCroLpBalance from './useVvsCroLpBalance';
import useVvsLpBalance from './useVvsLpBalance';

const useLpTokenBalance = (coinMode: CoinMode, gardenType: GardenType) => {
  const { tlcroBalance, loading: isTectonicLoading } = useTLcroBalance({
    enabled: gardenType === 'TECTONIC',
  });
  const { ferroLpBalance, loading: isFerroLoading } = useFerroLpBalance({
    coinMode,
    enabled: gardenType === 'FERRO',
  });
  const { vvsLpBalance, loading: isVvsLoading } = useVvsLpBalance({
    enabled: gardenType === 'VVS',
  });
  const { vvsCroLpBalance, loading: isVvsCroLoading } = useVvsCroLpBalance({
    enabled: gardenType === 'VVS_CRO',
  });

  let balance = ferroLpBalance;
  let loading = isFerroLoading;
  switch (gardenType) {
    case 'VVS':
      balance = vvsLpBalance;
      loading = isVvsLoading;
      break;
    case 'VVS_CRO':
      balance = vvsCroLpBalance;
      loading = isVvsCroLoading;
      break;
    case 'TECTONIC':
      balance = tlcroBalance;
      loading = isTectonicLoading;
      break;
  }

  return { balance, isLoading: loading };
};

export default useLpTokenBalance;
